import React from "react";
import { Link } from "react-router-dom";
import ReactFlow, { Controls, Background, ControlButton, ConnectionLineType } from 'reactflow';
import { Loading, StyleTag } from "seed/helpers";
import Node from "components/studio/board/nodes/Node";
import Edge from "components/studio/board/nodes/Edge";
import Note from "components/studio/board/annotations/Note";
import Pipe from "components/studio/board/annotations/Pipe";
import Text from "components/studio/board/annotations/Text";
import NodeAnnotation from "components/studio/board/annotations/Node";
import ActionItem from "components/studio/board/Board.sub.ActionItem.view";
import "styles/css/studio/board/Board.css";
import 'reactflow/dist/style.css';



const nodeTypes = {
  "pipe": Pipe,
  "note": Note,
  "node": Node,
  "node_annotation": NodeAnnotation,
  "text": Text,
}

const edgeTypes = {
  "edge": Edge
}

const BoardView = ({
  nodes,
  edges,
  defaultViewport,
  reactFlowWrapper,
  setReactFlowInstance,
  onNodesChange,
  onEdgesChange,
  onClickConnectEdge,
  onClickUpdateEdge,
  onDropNode,
  onDragNode,
}) => (
  <div id="board-minified" className="h-100 w-100">
    <div ref={reactFlowWrapper} className="flow-wrapper">

      <ReactFlow
        defaultViewport={defaultViewport}
        fitView={false}
        fitViewOptions={{}}
        minZoom={0.3}
        maxZoom={1.7}
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        connectionMode={"loose"}
        connectionLineType={ConnectionLineType.SmoothStep}
        nodesFocusable={false}
        edgesFocusable={false}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onClickConnectEdge}
        onEdgeUpdate={onClickUpdateEdge}
        onInit={setReactFlowInstance}
        onDrop={onDropNode}
        onDragOver={onDragNode}
      >

        <div style={{
          "position": "absolute", bottom: "0px", right: "0", zIndex: 10,
          background: "#f8fafe", width: "60px", height: "20px"
        }}></div>

        {/* Extend Controls to implement undo and redo */}
        <Controls showFitView={false} showInteractive={false}
          position="bottom-right" style={{ bottom: "10px" }}>
        </Controls>

        <Background />
      </ReactFlow>

    </div>
  </div>
)


export default BoardView;